import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { commonStyles } from '../../../../styles/common';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ...commonStyles(theme),
    actionCell: {
      display: 'flex',
      alignItems: 'center',
      gap: `${theme.spacing(1)}px`,
    },
    actionButton: {
      borderRadius: '10%',
      padding: `${theme.spacing(0.75)}px ${theme.spacing(0.875)}px`,
    },
    ticketTableRow: {
      backgroundColor: theme.palette.background.paper + ' !important',
      border: `1px solid ${theme.palette.border}`,
    },
    tableHead: {
      backgroundColor: theme.palette.table.headerBackground + ' !important',
    },
    tableHeadCell: {
      color: theme.palette.text.secondary,
      fontWeight: 600,
    },
    filterDropdown: {
      background: theme.palette.background.paper,
    },
    filterWidth: {
      width: '13%',
    },
    filterGap: {
      display: 'flex',
      gap: theme.spacing(1),
    },
    filterContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: theme.spacing(1),
      gap: theme.spacing(1),
    },
    filterMinWidth: {
      width: '100px',
    },
    filterPadding: {
      padding: `${theme.spacing(1.9)}px`,
    },
    badge: {
      backgroundColor: theme.palette.errorText,
      borderRadius: '50%',
      color: 'white',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '18px',
      height: '18px',
      marginLeft: '8px',
      fontSize: '12px',
    },
    assetFilterWidth: {
      width: '20%',
    },
    searchFilterWidth: {
      width: '80%',
    },
    statusBadge: {
      fontSize: theme.spacing(1),
      color: theme.palette.errorText,
      borderColor: theme.palette.background.paper,
    },
    searchInTicketsPage: {
      minWidth: `${theme.spacing(35)}px`,
      borderRadius: '10%',
      '& div': {
        background: theme.palette.background.paper,
      },
      '& input': {
        padding: `${theme.spacing(1.9)}px`,
      },
    },
    buttonLabel: {
      display: 'flex',
      gap: `${theme.spacing(0.5)}px`,
      alignItems: 'center',
    },
    header: {
      padding: theme.spacing(3),
      borderBottom: `1px solid ${theme.palette.divider}`,
      position: 'sticky',
      top: 0,
      zIndex: 1,
      display: 'flex',
      gap: theme.spacing(2),
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
    },
    content: {
      minHeight: 'calc(100vh - 200px)', // Adjust based on your header/footer height
      padding: theme.spacing(3),
    },
    footer: {
      padding: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
      position: 'sticky',
      bottom: 0,
      backgroundColor: theme.palette.background.paper,
      zIndex: 1,
    },
    footerButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(2),
    },
    resetButton: {
      marginRight: theme.spacing(1),
    },
    submitButton: {
      minWidth: 120,
    },
    flexSpacebetween: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },

    // popup styles
    popupTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      color: theme.palette.text.secondary,
    },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      minWidth: `${theme.spacing(69)}px`,
    },
    dialogFieldFlow: {
      flexFlow: 'wrap',
    },
    assetsDropdown: {
      minWidth: '150px',
      marginBottom: theme.spacing(1),
      float: 'right',
      background: theme.palette.background.paper,
    },
    commentBlock: {
      background: '#EDEDED',
      padding: `${theme.spacing(2.5)}px ${theme.spacing(
        2.5,
      )}px 0px ${theme.spacing(2.5)}px`,
      borderRadius: theme.spacing(1),
    },
    editCommentBlock: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
    editActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
    },
    customPadding: {
      padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px ${theme.spacing(
        3,
      )}px`,
    },
    individualCommentAction: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(2),
    },
    reminderBlock: {
      background: '#EFEFFB',
      padding: `${theme.spacing(2.5)}px ${theme.spacing(
        2.5,
      )}px 0px ${theme.spacing(2.5)}px`,
      borderRadius: theme.spacing(1),
    },
    reminderIconText: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      fontWeight: 600,
    },
    reminderContentPadding: {
      padding: `${theme.spacing(2)}px 0px`,
    },

    // Ticket card styles

    ticketCardAction: {
      marginTop: 0,
    },
    width50Percent: {
      width: '50%',
    },
    actionButtonWidth: {
      width: `${theme.spacing(4.16625)}%`,
    },
    ticketCardContentPadding: {
      padding: `0px ${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(
        2,
      )}px`,
    },
    ticketValueFont: {
      fontWeight: 'bold',
      color: '#565656',
    },
    editButton: {
      padding: 0,
      color: theme.palette.text.primary,
    },
    dialogActions: {
      justifyContent: 'space-between',
      padding: theme.spacing(2),
    },
    deleteButton: {
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
    },
    // run state popup styles
    runStatePopupContent: {
      background: '#EFEFFB',
      display: 'flex',
      flexDirection: 'column',
      gap: `${theme.spacing(1.5)}px`,
      padding: `${theme.spacing(1.5)}px ${theme.spacing(1.5)}px`,
    },
    runStatePopupTitle: {
      color: '#1A1A1A',
      fontSize: '20px',
    },
    runStatePopupContentTitle: {
      color: '#1A1A1A',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '24px',
      display: 'flex',
      gap: `${theme.spacing(1)}px`,
    },
    runStatePopupContentText: {
      color: '#1A1A1A',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400,
    },
    justifyContentEnd: {
      justifyContent: 'flex-end',
    },
    popupError: {
      color: theme.palette.error.main,
      marginLeft: `${theme.spacing(4)}px`,
      marginBottom  : `${theme.spacing(2)}px`,
    }
  }),
);
